import { Observable } from 'rxjs'
import { apiUrl, httpGet, httpPut2, httpGetWithoutMunicipalityHeader } from 'services/httpService'
import { Municipality } from '../models/municipality'

export default class MunicipalityClient {
    public static getMunicipalities(): Observable<Municipality[]> {
        return httpGetWithoutMunicipalityHeader<Municipality[]>(apiUrl(`/municipalities`))
    }
}
